export const influencers = [
  {
    id: 'joe-rogan',
    name: 'Joe Rogan'
  },
  {
    id: 'jordan-peterson',
    name: 'Jordan Peterson'
  },
  {
    id: 'david-goggins',
    name: 'David Goggins'
  },
  {
    id: 'jocko-willink',
    name: 'Jocko Willink'
  },
  {
    id: 'andrew-huberman',
    name: 'Andrew Huberman'
  }
] as const;